import { Drawer } from '@mercai/clever'
import { useQueryClient } from '@tanstack/react-query'

import { QUERIES_ADMIN } from '@/services'

import { FinanceProfileHeader, ProfileCreditForm } from './components'

import type { ProfileCreditProps } from './profile-credit.type'

export const ProfileCredit = ({
  isOpen,
  onHandleOpen,
  financeProfileData,
  buyerProfileUuid,
}: ProfileCreditProps) => {
  const queryClient = useQueryClient()

  const onSuccessUpdated = () => {
    queryClient.invalidateQueries({
      queryKey: [QUERIES_ADMIN.PROFILE.module, buyerProfileUuid],
    })
  }

  return (
    <Drawer isOpen={isOpen} onHandleOpen={() => onHandleOpen(false)}>
      <FinanceProfileHeader onHandleOpen={onHandleOpen} />

      <ProfileCreditForm
        onHandleOpen={onHandleOpen}
        financeProfileData={financeProfileData}
        onSuccessUpdated={onSuccessUpdated}
        profileUuid={buyerProfileUuid}
      />
    </Drawer>
  )
}
